module.exports = __webpack_public_path__ + "fonts/Inter-200-latin35.260c81a.woff2";